<template>
  <button v-if="!text" @click.prevent="tryCreateNote" :class="[classes]">
    New Note
  </button>
  <a
    href="#"
    v-else
    @click.prevent="tryCreateNote"
    :class="[{ btn: !text }, classes]"
  >
    New Note
  </a>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  props: {
    text: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters({
      metadata: "getMetadata",
    }),
  },
  methods: {
    ...mapActions({
      createNote: "createNote",
    }),
    async tryCreateNote() {
      if (this.metadata.notesCount >= 500) {
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-light-blue",
            cancelButton: "btn text-medium-grey",
          },
          buttonsStyling: false,
        });

        const result = await swalWithBootstrapButtons.fire({
          title: "Are you sure?",
          text:
            "You already have 500 notes, creating new note will delete the oldest note.",
          showCancelButton: true,
          confirmButtonText: "Yes, fine",
          cancelButtonText: "No, I will delete one myself",
          reverseButtons: true,
        });
        if (result.isConfirmed) {
          const id = await this.createNote();
          if (id) {
            this.$router.push("/note/" + id);
          } else {
            console.error("error creating new note");
          }
        }
      } else {
        const id = await this.createNote();
        this.$router.push("/note/" + id);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
